// ─── API КЛИЕНТ ───────────────────────────────────────────────────────────────
// Единая точка HTTP-запросов. В рент-менеджере этот файл был, но без
// авто-обновления токена и без глобального обработчика 401.

const BASE = '/api';

async function request(method, path, body) {
  const token = localStorage.getItem('token');
  const opts = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  };

  const res = await fetch(BASE + path, opts);

  // Автоматический logout при истечении токена
  if (res.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
    throw new Error('Сессия истекла');
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || `Ошибка ${res.status}`);
    err.status = res.status;
    err.code = data.code;
    err.data = data;
    throw err;
  }
  return data;
}

export const get  = (path)         => request('GET',    path);
export const post = (path, body)   => request('POST',   path, body);
export const put  = (path, body)   => request('PUT',    path, body);
export const patch= (path, body)   => request('PATCH',  path, body);
export const del  = (path)         => request('DELETE', path);
